import * as React from 'react';

export default () => (
  <span>
    <h2>Welcome</h2>
    <div className='row'>
      <div className='col-md-12'>
        <img className='img-responsive' src='/images/pets.png' />
      </div>
    </div>
  </span>
);
